// extracted by mini-css-extract-plugin
module.exports = {"menu":"List_menu__1LdbI","list":"List_list__18J3i"};